export enum GeneralContextTestIds {
  NETWORK_REQUEST_ERROR_SNACKBAR = 'general-context-network-request-error-snackbar',
}

export enum CandidateNavbarDataTestIds {
  NAVBAR_MISSOURI_LOGO = 'navbar-missouri-logo',
  NAVBAR_TENNESSEE_LOGO = 'navbar-tennessee-logo',
  NAVBAR_NIMBLE_LOGO = 'navbar-nimble-logo',
  NOTIFICATION_BADGE = 'navbar-user-menu-notification-badge',
  MATCH_NOTIFICATION_CHIP = 'navbar-user-menu-match-dashboard-notification-chip',
  SIGN_UP_BUTTON = 'navbar-sign-up-redirect-button',
  LOGIN_BUTTON = 'navbar-login-redirect-button',
  SUPPORT_BUTTON = 'navbar-support-redirect-button',
  USER_MENU = 'navbar-user-menu-button',
  USER_MENU_MATCH_DASHBOARD = 'navbar-user-menu-button-match-dashboard',
  USER_MENU_MATCH_DASHBOARD_LABEL = 'navbar-user-menu-button-match-dashboard-label',
  USER_MENU_MATCH_DASHBOARD_NOTIFICATION_CHIP = 'navbar-user-menu-button-match-dashboard-label-notification-chip',
  USER_MENU_MATCH_ARCHIVE = 'navbar-user-menu-button-match-archive',
  USER_MENU_MATCH_ARCHIVE_LABEL = 'navbar-user-menu-button-match-archive-label',
  USER_MENU_PROFILE = 'navbar-user-menu-button-profile',
  USER_MENU_PROFILE_LABEL = 'navbar-user-menu-button-profile-label',
  USER_MENU_LOGOUT = 'navbar-user-menu-button-logout',
  USER_MENU_LOGOUT_LABEL = 'navbar-user-menu-button-logout-label',
  USER_MENU_RELEASE_HIJACK = 'navbar-user-menu-button-release-hijack',
  USER_MENU_RELEASE_HIJACK_LABEL = 'navbar-user-menu-button-release-hijack-label',
  USER_MENU_SUPPORT = 'navbar-user-menu-button-get-support',
  USER_MENU_SUPPORT_LABEL = 'navbar-user-menu-button-get-support-label',
}
